import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "_flex _rounded--large _bgc--lighter-10 _py-h _px-3 _ai-c _tc--inherit"
}
const _hoisted_2 = { class: "_flexcol _jc-fs _ai-fs _lhc _py-h" }
const _hoisted_3 = { class: "_fw-b" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "gfu-bt gfu-bt--b2 _ml-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")
  const _component_user_follow = _resolveComponent("user-follow")

  return (_openBlock(), _createBlock(_component_user_follow, {
    nickname: $props.nickname,
    "user-url-name": $props.userUrlName,
    "user-id": $props.userId,
    onAction: $options.onAction
  }, {
    default: _withCtx(({ isFollowing, onFollow, onUnfollow }) => [
      isFollowing
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_base_icon, {
              name: "heart",
              class: "_mr-2 _tc--accent"
            }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.Resources.Profile.YouAreFollowingThisUser), 1 /* TEXT */),
              _createElementVNode("a", {
                href: "#",
                class: "_tc--accent _ttl",
                onClick: _withModifiers(onUnfollow, ["prevent"]),
                "data-qa": "user-profile:UnfollowButton"
              }, _toDisplayString(_ctx.Resources.Profile.UserUnfollowAction), 9 /* TEXT, PROPS */, _hoisted_4)
            ])
          ]))
        : (_openBlock(), _createBlock(_component_base_button, {
            key: 1,
            theme: "accent",
            class: "_flex gfu-1of1 _jc-c _ai-fs",
            onClick: _withModifiers(onFollow, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_base_icon, {
                "icon-namespace": "ga",
                name: "heart-solid-icon"
              }),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.Resources.Profile.UserFollowAction), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"]))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["nickname", "user-url-name", "user-id", "onAction"]))
}